import { Form, FormInstance, Row } from "antd";
import { Loader } from "../../../../../HeaderActions/components/EmailsModal/components/Loader";
import { PayersList } from "../../PrintTaxModal/components/PayersList";
import { useFormattedOptions } from "../../PrintTaxModal/hooks/useFormattedOption";
import { useFetchListData } from "../hooks/useFetchListData";
import { PeriodItem } from "./PeriodItem";
import { Dayjs } from "dayjs";
import { useMemo } from "react";

type FormContentProps = {
  form: FormInstance;
  disabled: boolean;
  contractId: string;
  range: [Dayjs, Dayjs];
  type: 0 | 1 | 2;
};

export const FormContent = ({
  form,
  disabled,
  contractId,
  range,
  type,
}: FormContentProps) => {
  const { data, isLoading } = useFetchListData(contractId, type);

  const { options } = useFormattedOptions(
    data,
    type === 1 ? "payerId" : "payeeId",
    type === 1 ? "payerName" : "payeeName"
  );

  const initialValues = useMemo(
    () => ({
      dates: range,
    }),
    [range]
  );

  return (
    <Row className="d-block position-relative">
      {isLoading ? (
        <Row className="loader-container position-relative justify-center">
          <Loader />
        </Row>
      ) : (
        <Row>
          <Form
            form={form}
            autoComplete="off"
            layout="vertical"
            requiredMark={false}
            disabled={disabled}
            initialValues={initialValues}
          >
            <PeriodItem />

            <PayersList
              options={options}
              label={type === 2 ? "Payee" : "Payer"}
            />
          </Form>
        </Row>
      )}
    </Row>
  );
};
